module.exports = __webpack_public_path__ + "img/icons BFr_26.25c7ad49.png";